module.exports = __webpack_public_path__ + "media/images/datepicker/cal-e05d8b00f8595743d3326c92cd6f2365.gif";